export function centeredSegments(segments, totalLength) {
    const half = totalLength / 2;
    return segments.map(seg => {
        const fromX = half - seg.from[0];
        const toX = half - seg.to[0];
        return {
            from: [fromX, seg.from[1]],
            to: [toX, seg.to[1]],
            length: seg.length
        };
    });
}
export function centeredLine(lines, totalLength) {
    const half = totalLength / 2;
    return lines.map(line => {
        const X = half - line[0];
        return [X, line[1]];
    });
}
export function unCenteredLine(lines, totalLength) {
    const half = totalLength / 2;
    return lines.map(line => {
        const X = half + line[0];
        return [X, line[1]];
    });
}
export function placeBoardOnSegment(segment, board) {
    const center = (segment.from[0] + segment.to[0]) / 2;
    let shift = (board.shiftF + board.shiftB) / 2;
    return [
        center - shift,
        0,
        0,
    ];
}
